module.exports = __webpack_public_path__ + "img/resource-tech-image-03.1a7aa8d1.jpg";